<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <app-questionario-valutazione-usabilita [showAsCard]="false" [showTitle]="true" [showFullPage]="true"
                    (imDirty)="setDirty($event)"></app-questionario-valutazione-usabilita>
            </div>
        </div>
    </div>
</div>